(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-report"] && !Shopify.designMode) return;
  try {
    
  document.querySelector('[data-report-print]')?.addEventListener('click', () => window.print());

  } catch(e) { console.error(e); }
})();
})();
